import React from 'react'
import TournamentMatch from './TournamentMatch'
import TournamentStandings from './TournamentStandings'

// editable is already false here once the knockout phase starts — the
// caller decides that, this component just renders whatever it's given.
const TournamentGroups = ({ groups, editable, onSubmitResult }) => (
  <div className="tournament-groups">
    {groups.map((group) => (
      <div className="tournament-group" key={group.index}>
        <h2 className="tournament-group-title">Grupo {group.index + 1}</h2>
        <TournamentStandings standings={group.standings} />
        <div className="tournament-league-matches">
          {[...group.matches]
            .sort((a, b) => a.round - b.round)
            .map((match) => (
              <TournamentMatch key={match.id} match={match} editable={editable} onSubmit={onSubmitResult} />
            ))}
        </div>
      </div>
    ))}
  </div>
)

export default TournamentGroups
